import { RegexEditor } from '../utils/regex_editor'
import { _extended_email } from './_extended_email'

const _url = /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9-]+\.?)+[^\s<]*|^email/

export const url = new RegexEditor(_url, 'i')
  .replace('email', _extended_email)
  .getRegex()
